// extracted by mini-css-extract-plugin
export default {"viewHeader":"ViewHeader_viewHeader__d1gYY"};